var $e59d3fcf6a74c870$exports = {};
$e59d3fcf6a74c870$exports = {
    "pending": `laukiama`
};


export {$e59d3fcf6a74c870$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
